$(document).ready(function(){
    $('body').on('click', '.toggle-mobile-menu', function(e) {
        e.preventDefault();

        var parent = $(this).parents(".mobile-header");

        if (parent.hasClass("mobile-menu-open")) {
            $('.collapsing-menu').slideUp('fast');

            parent.removeClass("mobile-menu-open");
        } else {
            $('.collapsing-menu').slideDown('fast');

            parent.addClass("mobile-menu-open");
        }
    });

    $('[data-decode-email="true"]').each(function(){
        $(this).attr('href', atob($(this).attr('href')));
        $(this).text(atob($(this).text()));
    })

    if ($('.swiper-container').length) {
        new Swiper ('.swiper-container', {
            loop: true,
            autoHeight: $('.swiper-container').data('swiperAutoHeight'),
            autoplay: $('.swiper-container').data('swiperAutoplay') ? {
                delay: 5000
            } : false,
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            }
        });
    }

    $('body').on('click', '.my-ckie-consnt button', function(e) {
        e.preventDefault();

        Cookies.set('kultura_cookie_consent_accepted', '1', { expires: 60000});

        $(this).parent().fadeOut('fast', function(){
            window.location.reload();
        });
    });
});
